<template>
  <div>
    <div :style="rootStyle" class="try-cloud-dialog">
        <el-dialog
        :visible.sync="centerDialogVisible"
        :close-on-click-modal="false"
        :before-close="handleClose"
        :z-index="zIndex"
        width="50%"
        center>
        <el-form :model="form" :rules="rules" ref="ruleForm" >
            <div class="form-inline">
            <el-form-item prop="name">
                <svg-icon class="icon" icon-class="star" />
                <el-input v-model="form.name" placeholder="您的姓名"></el-input>
            </el-form-item>
            <el-form-item prop="phone">
                <svg-icon class="icon" icon-class="star" />
                <el-input v-model="form.phone" placeholder="您的电话"></el-input>
            </el-form-item>
            </div>
            <div class="form-inline">
            <el-form-item prop="email">
                <el-input v-model="form.email" placeholder="您的邮箱"></el-input>
            </el-form-item>
            <el-form-item prop="unit">
                <svg-icon class="icon" icon-class="star" />
                <el-input v-model="form.unit" placeholder="您的单位/学校"></el-input>
            </el-form-item>
            </div>
        </el-form>
        <div class="star"><svg-icon icon-class="star"></svg-icon>为必填项</div>
        <span slot="footer" class="dialog-footer">
            <el-button :disabled="btnConfirm" type="primary" @click="submitHandle">提交</el-button>
        </span>
        </el-dialog>
    </div>
    
    <Verify 
        :visible.sync="verifyVisible" 
        @valid-success="validSuccessHandler"
        @btn-close="btnOnCloseHandler"
    />
  </div>
</template>

<script>
import { submitInformation } from '@/api/data'
import elDialogHeaderContactUsBg from '@/assets/public-img/el-dialog-header-contact-us-bg.png'
import Verify from '@/components/Verify/index.vue'
import { CURRENT_WEBSITE_SUBMIT_FLAG } from '@/utils/constants.js'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    zIndex:[Number],
    submitMode:{
        type: [String,Number],
        default: CURRENT_WEBSITE_SUBMIT_FLAG
    }
  },
  components: {
    Verify
  },
  data () {
    const validateName = (rule, value, callback) => {
      const reg = /^[\u4e00-\u9fa5a-z-_.A-Z0-9]+$/
      if (value.trim() === '') {
        callback(new Error('请输入姓名'))
      } else if (value.trim().length < 2 || value.trim().length > 50) {
        callback(new Error('姓名长度应在2-50个字符之间'))
      } else if (!reg.test(value.trim())) {
        callback(new Error('请输入中英文数字及_-.'))
      } else {
        callback()
      }
    }
    const validateUnit = (rule, value, callback) => {
      const reg = /^[\u4e00-\u9fa5a-z-_.A-Z0-9]+$/
      if (value.trim() === '') {
        callback(new Error('请输入单位/学校'))
      } else if (value.trim().length < 2 || value.trim().length > 50) {
        callback(new Error('单位/学校长度应在2-50个字符之间'))
      } else if (!reg.test(value.trim())) {
        callback(new Error('请输入中英文数字及_-.'))
      } else {
        callback()
      }
    }
    const validatePhone = (rule, value, callback) => {
      if (value.trim() === '') {
        callback(new Error('请输入手机号'))
      } else {
        if (!/^1[3456789]\d{9}$/.test(value.trim())) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      }
    }
    return {
      btnConfirm: false,
      form: {
        name: '',
        phone: '',
        email: '',
        unit: ''
      },
      rootStyle: {
        '--el-dialog-header-bg': `url(${elDialogHeaderContactUsBg})`
      },
      rules: {
        name: [{ required: true, trigger: 'blur', validator: validateName }],
        phone: [{ required: true, trigger: 'blur', validator: validatePhone }],
        email: [
          { required: false, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        unit: [{ required: true, trigger: 'blur', validator: validateUnit }]
      },
      verifyVisible:false
    }
  },
  computed: {
    centerDialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    }
  },
  mounted () {},
  methods: {
    handleClose () {
      this.$refs.ruleForm.resetFields()
      this.centerDialogVisible = false
    },
    btnOnCloseHandler(){
        this.btnConfirm = false
    },
    submitHandle () {
      this.btnConfirm = true
      
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.verifyVisible = true
        } else {
          this.btnConfirm = false
        }
      })
    },
    validSuccessHandler(res){
        this.verifyVisible = false
        const data = {
          name: this.form.name.trim(),
          phone: this.form.phone.trim(),
          email: this.form.email.trim(),
          address: this.form.unit.trim(),
          captchaId:res.data,
          //   提交网站标识
          belongTo: this.submitMode
        }
        submitInformation(data).then((response) => {
            if (response.data.meta.status === 201) {
                this.$message({
                message: response.data.meta.msg,
                type: 'success'
                })
            } else {
                this.$message({
                    message: response.data.meta.msg,
                    type: 'error'
                })
            }
        }).catch((err) => {
            this.$message({
                message: err.message,
                type: 'error'
            })
        })
        this.centerDialogVisible = false
        this.btnConfirm = false
        this.$refs.ruleForm.resetFields()
    }
  }
}
</script>
<style lang="scss" scoped>
.try-cloud-dialog {
  width: 100%;
  min-width: 1300px;
  .form-inline{
    display: flex;
  }
  .star{
    color: #B9BABE;
    font-size: 12px;
  }
  /deep/ .el-form-item{
    margin-right: 3%;
    width: 47%;
    position: relative;
  }
  .icon{
      position: absolute;
      top: 18px;
      left: 8px;
      width: 4.85px;
      height: 4.68px;
      z-index: 99;
    }
  /deep/ .el-dialog{
    max-width: 720px;
    border-radius: 10px;
    .svg-icon{
      width: 4.85px;
      height: 4.68px;
      vertical-align: middle;
      margin-right: 5px;
    }
  }
  /deep/ .el-dialog__header{
    background: var(--el-dialog-header-bg) center no-repeat;
    height: 120px;
    padding: 0;
    border-radius: 10px 10px 0 0;
  }
  /deep/ .el-dialog__headerbtn .el-dialog__close{
    color: #fff;
  }
  /deep/ .el-button--primary{
    background: linear-gradient(180deg, #4679FB 0%, #253FC3 91%);
    border-radius: 4px 4px 4px 4px;
  }
  /deep/ .el-button{
    padding: 11px 52px;
    font-size: 18px;
  }
  /deep/ .el-dialog--center .el-dialog__body{
    padding: 30px 67px 16px 67px;
  }
  /deep/ .el-dialog__footer {
    padding-bottom: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TryDialog.vue